import React from 'react';

export default Component => props => (
    <Component
        className={`${props.className} cursor`}
        {...props}
    />
);
